import { render, staticRenderFns } from "./PolTypeScheme.vue?vue&type=template&id=15bcf972&"
import script from "./PolTypeScheme.vue?vue&type=script&lang=js&"
export * from "./PolTypeScheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports